import { SVGProps } from "react";

export function UserDetails(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6C9.66 6 11 7.34 11 9ZM14 20H2V18C2 15.79 4.69 14 8 14C11.31 14 14 15.79 14 18M7 9C7 9.55 7.45 10 8 10C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8C7.45 8 7 8.45 7 9ZM4 18H12C12 16.9 10.21 16 8 16C5.79 16 4 16.9 4 18ZM22 12V14H13V12M22 8V10H13V8M22 4V6H13V4H22Z" fill="currentColor"/>
        </svg>
    )
}